/**
 * Abbreviates a big number
 */
const abbreviateBigNumber = (num: number) => {
	if (num < 1000) {
		return num.toString();
	} else if (num < 10_000) {
		const value = Math.floor(num / 100) / 10;
		return `${value}k`;
	} else if (num < 1_000_000) {
		return `${Math.floor(num / 1000)}k`;
	} else if (num < 10_000_000) {
		const value = Math.floor(num / 100000) / 10;
		return `${value}m`;
	} else {
		return `${Math.floor(num / 1_000_000)}m`;
	}
};
export default abbreviateBigNumber;
